import { z } from 'zod'
import { ChangelogActionSchema, ChangelogUserSchema } from '@/schemas/changelog'

export const VolunteerCooperationChangelogSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  user: ChangelogUserSchema,
  action: ChangelogActionSchema
})

export const VolunteerCooperationDataSchema = z.object({
  volunteer_cooperation_mark: z.boolean(),
  volunteer_cooperation_changelogs: z.array(VolunteerCooperationChangelogSchema)
})

export const VolunteerCooperationResponseSchema = z.object({
  data: VolunteerCooperationDataSchema
})
